import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-hp-dropdown',
  templateUrl: './hp-dropdown.component.html',
  styleUrls: ['./hp-dropdown.component.scss']
})
export class HpDropdownComponent {
  @Input() list;
  @Input() data;
  @Input() ariaLabel = ''
  selectedLegend = []
  @Output() setValue = new EventEmitter();
  isListOpened = false;
  searchText = ''
  isActiveNOofCasesNo = true
  @Input() multi = false;
  @Input() autoClose = true;
  @Input() searchable = false;
  @Input() inputPlaceHolder = ''
  @Input() selectedOption;
  @Output() isOpen = new EventEmitter();
  @Input() clearIcon = false;
  @Input() showTick=false
  isHighlighted = false;
  @Input() selectionSeparation = false;
  @Input() disabled = false;
  @Input() disabledActive = false
  @Input() listStatus = false;
  @Input() hideError = false;
  @Input() clearAllFilter;
  @Input() primaryClr=false
  @Input() newOption = ''
  isFocused = false;
  @Input() datePicker = false;
  @Input() fromFilterEvents = false;
  @Input() toggleClick = true
  @Input() minDate = new Date();
  @Input() maxDate = null;
  @Input() hpDropdownMaxDate: boolean = false;
  selectedDate = "ESTIMATION_LIST.NEW_REQ.SELECT_DATE";
  isDateSelected = false;
  isDatePickerOpen = false;
  @Input() isClrShow = false;
  @Input() showToolTip = false;
  @Input() tooltipMessage = ''
  @Input() hasDateFilter = false
  @Input() hasEndSupportDate
  @Input() capitalizeFirstLetter = false;
  @Output() searchTextOnLabelClick  = new EventEmitter()
  @Input() disableUnSelection = false;
  highlightedIndex = -1;
  @ViewChild('dropdownList') dropdownList: ElementRef | undefined;
  @ViewChild('searchInput') searchInput: ElementRef
  @ViewChild('select') select: ElementRef
  @Input() tabindex = 0

  openDatePickerOnKeyStroke = {status: false};
  constructor(private cdr: ChangeDetectorRef,
              private commonService: CommonService,              
              private liveAnnouncer: LiveAnnouncer,
              private translate: TranslateService
            ) { }

  ngOnChanges(changes: SimpleChanges) {
    for (let prop in changes) {
      /**detect the changes of legend value */
      if (prop == 'list' && this.list && this.list?.length) {
        this.selectedLegend = this.list.filter(ele => ele.active ==true )
        this.cdr.detectChanges();
      }
      if (prop == 'list' && this.list && this.list?.length == 0) {
        this.selectedLegend = []
        this.cdr.detectChanges();
      }
     // clear all filter
     if(prop == 'clearAllFilter' && this.selectedLegend) {
      this.selectedLegend = []
      this.setValue.emit(this.selectedLegend);
      this.list.map(ele => ele.active = false)
     }
     if(prop == 'selectedOption' && this.selectedOption?.length) {
      // this.selectedLegend = this.selectedOption
      this.selectedLegend = this.list?.filter(ele => ele.active ==true )
        this.cdr.detectChanges();
     }else if(this.selectedOption?.length == 0){
       this.selectedLegend = []
     }
      // if a date is selected
      else if (prop == 'datePicker' && !Array.isArray(this.selectedOption) &&
        this.selectedOption != 'autorenewal') {
        this.getSelectedDate(this.selectedOption);
      }
      if (prop == 'datePicker' && this.selectedOption == 'autorenewal') {
        this.selectedLegend = this.list?.filter(ele => ele.value == 'autorenewal');
        this.selectedLegend[0]['active'] = true;
        this.cdr.detectChanges();
        this.isDatePickerOpen = false;
      }
    }
  }

  @HostListener('document:click')
  clickout() {
    if (!this.isDatePickerOpen) {
      if (this.isListOpened) {
        if(this.data[0].addNew && this.newOption) { // auto update input once clicked outside
          this.addNewOption(this.data[0].source)
        }
        this.isHighlighted = true
      } else {
        this.isHighlighted = false
        this.searchText = '';
      }
      this.highlightedIndex = -1;
      this.isListOpened = false;
      this.isOpen.emit(this.isListOpened);
      localStorage.setItem("openStatus", JSON.stringify(this.isListOpened))
      this.searchText = ''
    }
  }

  @HostListener('document:keydown.ArrowUp', ['$event'])
  handleArrowUpKey(event: KeyboardEvent): void {
    this.navigateOptions('up'); // Move up 
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('document:keydown.ArrowDown', ['$event'])
  handleArrowDownKey(event: KeyboardEvent): void {
    this.navigateOptions('down'); // Move down 
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('window:keypress', ['$event'])
  esc(event: KeyboardEvent): void {
  if(event.key == 'Escape') {
    this.closeDropdown(event)
  }
  }

  /**
   * select the legend and emit the same
   * @param legend slected legend
   **/
  onSetLegend(legend, event) {
    if(legend?.disabled || (this.disableUnSelection && legend?.active)) {
      return
    }

    this.isDateSelected = false;
    if(legend==undefined){
      return
    }
    if(!this.autoClose) {
      event.stopPropagation()
    }
    this.emitSearchQuery(this.searchText)
    if(this.toggleClick) {
      //toggle click
      legend.active = !legend.active;
    } else {
      //non toggle click
      this.list.map(ele => {
        if(ele.value == legend.value) {
          ele.active =  true
        } else {
          ele.active = false;
        }
      })
    }

    if(!this.multi) {
      this.searchText = ''
      this.list.map(ele => {
        if(ele.value == legend.value) {
          ele.active =  legend.active
        } else {
          ele.active = false;
        }
      })
      }

    this.selectedLegend = this.list.filter(ele => ele.active ==true)
    if(this.fromFilterEvents) { // history page dropdown event
      let selectedLegendFromEvents = []
      this.selectedLegend.length ? selectedLegendFromEvents.push(legend.value): selectedLegendFromEvents = [];
      this.setValue.emit(selectedLegendFromEvents);
    } else {
      this.setValue.emit(this.selectedLegend);
    }

    setTimeout(() => {
      if(!this.isListOpened) {
        this.isHighlighted = true
        this.select.nativeElement.focus();
      } 
    });
    if(this.multi) {
      this.searchable && this.searchInput.nativeElement.focus()
      !this.searchable && this.focusCurrentOption(0)
    }
    if(!this.multi && this.isListOpened)  {
      event.stopPropagation && event.stopPropagation();
      this.closeDropdown(event)
    }
  }

  /** hide or show the dropdown list
   * @param this.isListOpened initially list should be in hidden state
   */
  toggle(e) {
    this.isHighlighted = false
    let openStatus = JSON.parse(localStorage.getItem('openStatus')) // to track the status of dropdown is opened
    if(openStatus) {
      this.clickout();
      return
    }
    e.stopPropagation();
    e.preventDefault();
    this.isFocused = true
    this.isListOpened = !this.isListOpened;
    this.isOpen.emit(this.isListOpened);
    if(!this.isListOpened) {
      this.isHighlighted = true
    } else{
      setTimeout(() => {
        document.getElementById('search')?.focus()
      }, 100);
    }
   
      if(this.searchable && this.isListOpened) {
        setTimeout(()=>{
          this.searchInput.nativeElement.focus()
        })
      }
  
   localStorage.setItem("openStatus",JSON.stringify(this.isListOpened))
  }

  openDropdown(e){
    e.stopPropagation();
    e.preventDefault();
    this.isHighlighted = false
    let openStatus = JSON.parse(localStorage.getItem('openStatus')) // to track the status of dropdown is opened
    if(openStatus) {
      return
    }
    this.isFocused = true
    this.isListOpened = true;
    this.isOpen.emit(this.isListOpened);
  
  if(this.searchable && this.isListOpened) {
    setTimeout(()=>{
      this.searchInput.nativeElement.focus()
    })
  }
   localStorage.setItem("openStatus",JSON.stringify(this.isListOpened))
  }

  closeDropdown(e){
    this.isHighlighted = false
    this.isListOpened = false
    // let openStatus = JSON.parse(localStorage.getItem('openStatus')) // to track the status of dropdown is opened
    // if(openStatus) {
       this.clickout();
        this.select.nativeElement.focus();
    // }
  }

  clearAll(e) {
    e.stopPropagation();
    e.preventDefault();
    this.isHighlighted = false;
    this.selectedLegend.forEach(ele => ele.active = false);
    this.selectedLegend = this.list.filter(ele => ele.active ==true )
    this.setValue.emit(this.selectedLegend);
    this.clickout();
  }

  addNewOption(field){
    this.selectedLegend = []
    this.list.map(ele => ele.active = false)
    let time = new Date()
    let legend = { label: this.newOption, value: this.newOption, error_code: this.newOption, event: "", timestamp: time.toISOString(), active: true }
    this.list.push(legend)
    this.selectedLegend = [legend]
    this.setValue.emit(this.selectedLegend);
    this.isListOpened = false;
    this.isHighlighted =true
    this.newOption = ''
  }
  validateNumber(field, event){
    if(field == 'log'){
      var charCode = (event.which) ? event.which : event.keyCode;
      // Only Numbers 0-9
      if ((charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    }
  }

  addNewSite(eve){
    this.onSetLegend(this.selectedLegend[0],eve)
    this.selectedLegend = [{label: "Add new site", value: true,location: true,active:true}]
    this.setValue.emit(this.selectedLegend);
  }

  stopEvent(e) {
    if(!this.autoClose) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  getSelectedDate(event) {
    this.selectedDate = this.commonService.formatDate(event)
    this.onSetLegend(this.selectedLegend[0], event);
    this.isDateSelected = true;
    this.selectedLegend = [{label: this.selectedDate, value: this.selectedDate, active:true}];
    this.setValue.emit(this.selectedLegend);
    this.setValue.emit(event);
    this.isDatePickerOpen = false;
  }

  datePickerOpenState(event) {
    this.isDatePickerOpen = event;
  }

  getStyle(style){
    let data={"background":style}
    return data
  }

  emitSearchQuery(searchText) {
    this.searchTextOnLabelClick.emit(searchText)
  }

  /**
   * To handle Arrow Up & Down options navigation
   * @param direction can be either 'up' or 'down'
   * @returns void
   */

  navigateOptions(direction: 'up' | 'down'): void {
    if (!this.isListOpened) {
      return;
    }
    let currIndex = -1;
    let selectedOptions = [];
    let unSelectedOptions = [];
    this.list.forEach((item: any, index: number) => item.active ? selectedOptions.push(index) : unSelectedOptions.push(index));
    let mergeOptionsIndex = [...selectedOptions, ...unSelectedOptions];
    if (this.multi) {
      currIndex = this.handleMultiSelectOptionFocus(mergeOptionsIndex, direction);
    } else {
      currIndex = this.handleSingleSelectOptionFocus(direction);
    }    
    this.focusCurrentOption(currIndex);
  }

  handleMultiSelectOptionFocus(mergeOptionsIndex: number[], direction: 'up' | 'down'): number {
    if (this.highlightedIndex === -1) {
      return mergeOptionsIndex[0];
    }
    let currOptionIndex = mergeOptionsIndex.findIndex(item => item === this.highlightedIndex);
    return direction === 'down' ? mergeOptionsIndex[currOptionIndex + 1] : mergeOptionsIndex[currOptionIndex - 1];
  }

  handleSingleSelectOptionFocus(direction: 'up' | 'down'): number {
    if (this.highlightedIndex === -1) {
      return 0;
    }
    return (this.highlightedIndex + (direction === 'down' ? 1 : -1));
  }

  focusCurrentOption(currIndex: number): void {
    if(this.list.length == 0) {
      this.liveAnnouncer.announce(this.translate.instant('HP_DROP_DOWN.NO_DATA'));
      return
    }
    if (currIndex >= 0 && currIndex < this.list.length) {
      this.highlightedIndex = currIndex;
      let listElement = this.dropdownList.nativeElement;
      setTimeout(() => {
        listElement.querySelector("li.highlightedIndexClass")?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        listElement.querySelector("li.highlightedIndexClass")?.focus();
      });
    }
  }

  initDatePicker(){
    this.openDatePickerOnKeyStroke = {status: true};
  }
}

